// Service Worker Registration for PWA
// This code will register the service worker when the app loads

import { LogLevel, PwaLogging } from '@nutrien/ddc-fe-logging-pwa';

import { DemoSchema } from './schema';

export function registerServiceWorker(logging: PwaLogging<DemoSchema>) {
  navigator.serviceWorker
    ?.register('/serviceWorker.js')
    .then(() => {
      logging.levelEventLogger(LogLevel.info, 'Service worker registered successfully');
    })
    .catch(error => {
      logging.errorLogger(error, { message: 'Service worker registration failed' });
    });
}
